export default __webpack_public_path__ + "static/media/doc6.01594941.jpeg";